/* eslint-disable global-require,import/no-dynamic-require */
import {
  LocalizationContextBuilder,
  MessageBundle,
  LocalizationContext,
} from '@amzn/arb-tools';
import arbManifest from '../i18n/translations/PublicNoticeForm/arbManifest';
import { DEFAULT_LOCALE } from './constants';
import { useBundle } from '@amzn/react-arb-tools';
import { PublicNoticeFormStrings } from './constants';

const LOCALIZATION_CONTEXTS = new Map<string, LocalizationContext>();

export function getLocalizationContext(locale: string) {
  let lc = LOCALIZATION_CONTEXTS.get(locale);

  if (!lc) {
    lc = new LocalizationContextBuilder()
      .withLocale(locale)
      .withDefaultLocale(DEFAULT_LOCALE)
      .build();

    LOCALIZATION_CONTEXTS.set(locale, lc);
  }

  return lc;
}

export function t(
  bundle: MessageBundle,
  stringId: string,
  args?: Record<string, unknown>
) {
  try {
    if (!bundle || !stringId) {
      return undefined;
    }
    if (!args) {
      return bundle.getMessage(stringId);
    }
    if (args) {
      return bundle.formatMessage(stringId, args);
    }
  } catch (e) {
    console.error(e);
    console.error('Error in bundle', bundle, 'with message', stringId, 'args', args)
    return undefined;
  }
}
 
export function resolveBundleUrlWithFallbacks(
  resourcePackPath: string | undefined,
  locale: string,
  bundle: string
) {
  try {
    const translations = require(`../i18n/translations/${bundle}`).default;
    const arbManifest = require(`../i18n/translations/${bundle}/arbManifest`).default;

    if (resourcePackPath && translations[resourcePackPath]) {
      return translations[resourcePackPath];
    }

    if (!resourcePackPath && arbManifest.endpointMap?.[locale]?.[bundle]) {
        return translations[arbManifest.endpointMap[locale][bundle]];
    }

    if (arbManifest.endpointMap?.[DEFAULT_LOCALE]?.[bundle]) {
      return translations[arbManifest.endpointMap[DEFAULT_LOCALE][bundle]];
    }
  } catch (error) {
    console.error(`There was a problem importing translation module with bundle ${bundle}`);
    return null;
  }
}
 
export function getMbmOptions(locale: string) {
  const localizationContext = getLocalizationContext(locale);

  return {
    arbManifest,
    defaultLocalizationContext: localizationContext,
    resolveBundleUrl: (
      resourcePackPath: string | undefined,
      locale: string,
      bundle: string
    ) => {
      return resolveBundleUrlWithFallbacks(resourcePackPath, locale, bundle);
    },
  };
}
 
export const usePNFTranslation = (): PNFTranslationFunction => {
  const [pnfStrings] = useBundle(PublicNoticeFormStrings);

  return (key: string, options?: Record<string, any>) => {
    return t(pnfStrings, key, options) || key;
  };
};

export type PNFTranslationFunction = (key: string, options?: Record<string, any>) => string;
